import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import decode from "jwt-decode";
import moment from "moment";
import { message } from "antd";

const AuthContext = createContext();

export const AuthWrapper = ({ children }) => {
  const navigate = useNavigate();
  // var user = JSON.parse(localStorage.getItem("stt"));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("stt")));

  useEffect(() => {
    if (user) {
      const decodedToken = decode(user.accessToken);
      // const tokenExpiration = moment.unix(decodedToken.exp).format('MM DD YYYY, h:mm:ss a');
      // const currentDate = moment(new Date().valueOf()).format('MM DD YYYY, h:mm:ss a');
      let date = moment().unix(new Date().valueOf());
      // if (Date.parse(currentDate) > Date.parse(tokenExpiration)) {
      if (date > decodedToken.exp) {
        localStorage.removeItem("stt");
        navigate("/");
        setUser(null);
        window.location.reload();
      }
    }
    // }, []);
  }, [user, navigate]);

  const login = async (data) => {
    //รับค่าจากbackendมาเพื่อเก็บไว้ในlocal
    const result = {
      accessToken: data.token,
      ...data,
    };

    localStorage.setItem("stt", JSON.stringify(result));
    navigate("/");

    const section = localStorage.getItem("confooterSection");
  };

  const logout = () => {
    let user = {
      accessToken:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjpudWxsLCJyb2xlX2lkIjoiYTQyZjVjOTktMjkxYS0xMWVmLThjMzYtMDI0MmFjMTUwMDA2Iiwib3JnX2lkIjoiZTgyZmI3ZjMtM2ZhMC00NDZkLThlZjQtOTc0MzQyMWI0Y2E4IiwiaWF0IjoxNzE4NzY2NzIzLCJleHAiOjE3MTkwMjU5MjN9.QnseLdlu9O9BQQKhjXizXc_AgaFQATS2tCxHpSeeQzc",
      user_status: 1,
      user_id: null,
      user_name: null,
      profile_img: null,
      org_id: "e82fb7f3-3fa0-446d-8ef4-9743421b4ca8",
      org_name: "Ai9",
      role: "User",
      token:
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjpudWxsLCJyb2xlX2lkIjoiYTQyZjVjOTktMjkxYS0xMWVmLThjMzYtMDI0MmFjMTUwMDA2Iiwib3JnX2lkIjoiZTgyZmI3ZjMtM2ZhMC00NDZkLThlZjQtOTc0MzQyMWI0Y2E4IiwiaWF0IjoxNzE4NzY2NzIzLCJleHAiOjE3MTkwMjU5MjN9.QnseLdlu9O9BQQKhjXizXc_AgaFQATS2tCxHpSeeQzc",
      expiresIn: null,
    };
    localStorage.setItem("stt", JSON.stringify(user));
    navigate("/");
    window.location.reload();
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
